import request from './axiosFun';
import apiHttp from './apiHttp';
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// // 上传图片
// export function uploadFile(data) {
//   return request({
//     url: url + '/pasture/sys/uploadFile',
//     method: 'post',
//     data,
//     notoken: 'old'
//   });
// }

// 首页数据统计
export function findHomeDataCount(query) {
  return request({
    url: url + '/project-server/ziZhouDataInfo/findHomeDataCount',
    method: 'post',
    data: query
  });
}
// 首页屠宰监管
export function findButcherCount(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/findButcherCount',
    method: 'post',
    data: query
  });
}
// 首页技术服务
export function findExpertCount(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/findExpertCount',
    method: 'post',
    data: query
  });
}
// 首页物料统计
export function findMaterCount(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/findMaterCount',
    method: 'post',
    data: query
  });
}
// 首页政策行情列表
export function findNoticeList(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/findNoticeList',
    method: 'post',
    data: query
  });
}
// 大屏数据总览
export function getScreenDataOverview(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/getScreenDataOverview',
    method: 'post',
    data: query
  });
}
// 在栏畜只排名
export function getFarmLivestockSortList(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/getFarmLivestockSortList',
    method: 'post',
    data: query
  });
}
// 实时监控视频
export function queryFarmDeviceData(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/queryFarmDeviceData',
    method: 'post',
    data: query
  });
}
// 屠宰场实时监控视频
export function getScreenButcherNewDataList(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/getScreenButcherNewDataList',
    method: 'post',
    data: query
  });
}
// 大屏专家
export function queryExpertUserInfo(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/queryExpertUserInfo',
    method: 'post',
    data: query
  });
}
// 大屏专家推荐
export function queryRecommendExpertUserInfo(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/queryRecommendExpertUserInfo',
    method: 'post',
    data: query
  });
}
// 屠宰场进场统计
export function getScreenButcherLivestockCount(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/getScreenButcherLivestockCount',
    method: 'post',
    data: query
  });
}
// 辖区养殖场/户数统计
export function getAreaFarmCount(query) {
  return apiHttp({
    url: url + '/project-server/ziZhouDataInfo/getAreaFarmCount',
    method: 'post',
    data: query
  });
}

// 新权限初始化数据
export function getMenuTreeByApplicationId(query) {
  return apiHttp({
    url: url + '/pasture-manage/sysManage/getMenuTreeByApplicationId',
    method: 'post',
    data: query
  });
}
// 经营主体列表
export function findFarmInfoList(query) {
  return request({
    url: url + '/pasture/farmInfo/findFarmInfoList',
    method: 'post',
    data: query
  });
}
// 经营主体列表详情
export function findFarmInfoDetail(query) {
  return request({
    url: url + '/pasture/farmInfo/findFarmInfoDetail',
    method: 'post',
    data: query
  });
}
// 查询子洲专家列表接口
export function selectExpertUserInfoList(query, loading) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/study/expertUserInfo/selectExpertUserInfoList',
    method: 'post',
    data: query
  });
}
// 查询黄蒿界镇专家列表接口
export function selectExpertUserInfoList_HHJZ(query, loading) {
  // query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/study/expertUserInfo/selectExpertUserInfoList',
    method: 'post',
    data: query
  });
}
// 通过手机号查询专家信息
export function queryExpertInfoByUserAccount(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/expertUserInfo/queryExpertInfoByUserAccount',
    method: 'post',
    data: query
  });
}
// 绑定/解绑 专家到子洲
export function bindExpert2Project(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/expertUserInfo/bindExpert2Project',
    method: 'post',
    data: query
  });
}

// 课程管理分页列表接口
export function pageCourseManagement(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/wisdomManage/liveStudy/pageCourseManagement',
    method: 'post',
    data: query
  });
}
// 新增课程管理
export function insertCourseManagement(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/wisdomManage/liveStudy/insertCourseManagement',
    method: 'post',
    data: query
  });
}
// 编辑课程管理
export function updateCourseManagement(query) {
  return request({
    url: url + '/study/wisdomManage/liveStudy/updateCourseManagement',
    method: 'post',
    data: query
  });
}
// // 查询课程视频分页列表
// export function selectVideoCourseListByUserId(query) {
//   return request({
//     url: url + '/study/videoCourseData/selectVideoCourseListByUserId',
//     method: 'post',
//     data: query
//   });
// }

// 直播培训
export function pageLiveCreateRoom(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/wisdomManage/liveStudy/pageLiveCreateRoom',
    method: 'post',
    data: query
  });
}
// 新增直播培训
export function getLivePushUrl(query) {
  return request({
    url: url + '/study/liveStudy/getLivePushUrl',
    method: 'post',
    data: query
  });
}
// 编辑（删除）直播培训
export function updCreateRoomData(query) {
  return request({
    url: url + '/study/liveStudy/updCreateRoomData',
    method: 'post',
    data: query
  });
}
//（删除）直播培训历史下的视频
export function delOrUpdVideoData(query) {
  return request({
    url: url + '/study/videoUpload/delOrUpdVideoData',
    method: 'post',
    data: query
  });
}

// 查询播放信息
export function queryLiveRoomAndVideoList(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/liveStudy/queryLiveRoomAndVideoList',
    method: 'post',
    data: query
  });
}

// 查询课程视频分页列表
export function selectVideoCourseListByUserId(query) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  return request({
    url: url + '/study/videoCourseData/selectVideoCourseListByUserId',
    method: 'post',
    data: query
  });
}

// 课程视频新增
export function addVideoCourseData(query) {
  return request({
    url: url + '/study/videoCourseData/addVideoCourseData',
    method: 'post',
    data: query
  });
}
// 课程视频编辑
export function updVideoCourseData(query) {
  return request({
    url: url + '/study/videoCourseData/updVideoCourseData',
    method: 'post',
    data: query
  });
}
// 课程视频删除
export function delVideoCourseData(query) {
  return request({
    url: url + '/study/videoCourseData/delVideoCourseData',
    method: 'post',
    data: query
  });
}

// 视频管理列表（新）
export function pageCourseData(query, loading) {
  query.openRealAreaId = JSON.parse(localStorage.getItem('zizhouuserInfo')).openRealAreaId;
  const _request = loading ? apiHttp : request;
  return _request({
    url: url + '/study/videoCourseData/pageCourseData',
    method: 'post',
    data: query
  });
}

// 上传视频
export function uploadVodFile(query) {
  return request({
    url: url + '/study/videoUpload/uploadVodFile',
    method: 'post',
    data: query
  });
}
// 根据id查询视频
export function queryVideoDetailedByTitle(query) {
  return request({
    url: url + '/study/videoUpload/queryVideoDetailedByTitle',
    method: 'post',
    data: query
  });
}

// 视频观看数量增加
export function addVideoLookNumber(query) {
  return apiHttp({
    url: url + '/study/videoUpload/addVideoLookNumber',
    method: 'post',
    data: query
  });
}

export function getEstrusLivestockPcList(query) {
  return request({
    url: url + '/livestock/baFuLivestock/getEstrusLivestockPcList',
    method: 'post',
    data: query
  });
}
export function recommendExpert(query) {
  return request({
    url: url + '/study/expertUserInfo/recommendExpert',
    method: 'post',
    data: query
  });
}
// 地图
export function getFarmMapList(query) {
  return request({
    url: url + '/project-server/ziZhouDataInfo/getFarmMapList',
    method: 'post',
    data: query
  });
}

// 榆林用户注册数据
export function findLatitudeAndLongitudeGroup(query) {
  return apiHttp({
    url: url + '/project-server/latitudeAndLongitude/findLatitudeAndLongitudeGroup?bit=1',
    method: 'get'
  });
}

// 榆林演示接口
export function findScreen(query) {
  return request({
    url: url + '/project-server/screen/findScreen',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/zzry.js